<template>
  <div>
    <b-card class="parent">
      <b-row class="justify-content-between align-items-center" >
        <b-col cols="4">
          <div>
            <b-row>
              <div>
                <collapse-button
                  :toggle="`child-${notification.id}`"
                  :expanded="isExpanded"
                />
              </div>
              <span class="notification-date">
                {{ getDate(notification.created) }}
              </span>
              <span class="subject">
                {{ notification.subject }}
              </span>
            </b-row>
          </div>
        </b-col>
        <b-col cols="3">
          <a class="url" :href="notification.redirectUrl">{{
            notification.redirectUrl
          }}</a>
        </b-col>
        <b-col cols="2" class="d-flex justify-content-end">
          <b-button
            class="btn-outline-red"
            @click="markAsRead()"
            v-if="!notification.isRead"
          >
            {{ $t("mark_as_read") | capitalize }}
          </b-button>
        </b-col>
      </b-row>
      <b-collapse v-model="isExpanded" :id="`child-${notification.id}`">
        <b-card class="child">
          <div v-html="notification.body"></div>
        </b-card>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import moment from "moment"

export default {
  name: "Notification",
  props: {
    notification: Object,
  },
  data () {
    return {
      isExpanded: false
    }
  },
  methods: {
    ...mapActions("actionTabs", ["decrementUserActionCount"]),
    getDate (date) {
      return moment(date).format("YYYY-MM-DD HH:mm")
    },
    markAsRead () {
      if (!this.notification.read) {
        this.$api.notifications.markRead(this.notification.id).then(() => {
          this.decrementUserActionCount("notificationActionsCount")
          this.$emit("update-notifications")
        })
      }
    },
  },
}
</script>

<style language="scss" scoped>
.parent {
  background: #f1f1f1;
  padding: 0 5px;
  margin: 10px 0;
}

.child {
  background: lightgrey;
  margin: 10px;
}

tr {
  background: red !important;
}

.subject {
  padding-left: 15px;
}

.url {
  text-decoration: none;
  color: var(--blue);
}

.notification-date {
  color: var(--gray);
  padding-left: 15px;
}
</style>
